import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function TiDepartment() {
    return (
        <>
            <Header />

            <main>
                <section class="pad breadcrumbs top-cover">

                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Technology Innovations Department</span>
                    </div>
                    <div data-lavalamp=""></div>
                </section>

                <section class="pad bank-benefits default">

                    <div class="content normal margin-top-content">

                        <div class="data">
                            <div class="text">
                                <h3 class="title">Technology Innovations Department</h3>
                                <p class="subtitle">
                                    Developments in progress
                                </p>
                                <br></br>
                                <p class="subtitle">
                                    Research and Development Departments working on upcoming
                                    Technological Innovations in Enegry, Meta, Medical. They include<br></br><br></br>

                                    • NU-Fuel<br></br>
                                    • Artificial Arm<br></br>
                                    • AI Sensory Glove<br></br>
                                    • ZACU Coin<br></br>
                                    • Meta Medical EMPT Suit<br></br>
                                    • Electro Magnetic Pulse Therapy<br></br>
                                    • Payment Gateway Machine<br></br>
                                    • NUMeta Hardware<br></br>
                                    • Meta-Arts Realm<br></br>
                                    • Meta Realm


                                </p>


                            </div>

                        </div>

                        <div class="img-frame">

                            <img src="images/nugenesisou/pr-illustration-15.png" alt="" />
                        </div>


                        <div data-lavalamp=""></div>
                    </div>

                </section>

               


            </main>
            <Footer />
        </>
    )
}